import { BASE_MOBILE_NAME, TENDER_REDIRECT } from '@constants';
import { clearStorage, getStorage } from './localStorageService';

// 是否手机端
export const isMobile = !!window.navigator.userAgent.match(
  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
);
// 是否企业微信
export const isComWx = /wxwork/i.test(navigator.userAgent);

export const browserCheckHandle = (
  navigate: any,
  isNavigate: boolean = false
) => {
  if (isMobile) {
    const redirectUrl = getStorage(TENDER_REDIRECT);
    // // @ts-expect-error
    // location.href = process.env.React_APP_BASE_RELOAD
    clearStorage(TENDER_REDIRECT);
    // navigate(`/temporaryNoPhonePage`);
    // return;

    if (!isNavigate) {
      navigate(`/temporaryNoPhonePage`, {
        replace: true
      });
      return;
    }

    if (redirectUrl) {
      window.location.replace(
        `${location.origin}${BASE_MOBILE_NAME}${redirectUrl}`
      );
      // window.location.href = `${location.origin}${BASE_MOBILE_NAME}${redirectUrl}`;
    } else {
      window.location.replace(`${location.origin}${BASE_MOBILE_NAME}/login`);
      // window.location.href = `${location.origin}${BASE_MOBILE_NAME}/login`;
    }
  }
};
